import { gql } from '@apollo/client/core';

export const deleteFacilityNotepadEntry = gql`
  mutation deleteFacilityNotepadEntry($id: String!) {
    deleteFacilityNotepadEntry(id: $id) {
      value
    }
  }
`;
